import React, { useEffect } from 'react';
import styled from 'styled-components';
import Modal from '../Modal';

const ModalHeaderContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
`;

const ModalHeaderTitleContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
`;

const ModalHeaderCloseButtonContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
`;

const ResultCardContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    background-color: #F5F5F5;
    border-radius: 8px;
    padding: 0.5rem 1rem;
    margin: 1rem 0;
    box-shadow: 0px 2px 5px rgba(0,0,0,0.5);
    cursor: pointer;
`;

const ResultCardContent = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    flex: 10;
`;

const ResultCardArrowContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex: 1;
`;

const ResultCardArrow = styled.span`
    font-size: 2em;
    color: #56050D;
`;

const CloseButton = styled.button`
    position: absolute;
    background: transparent;
    border: none;
    font-size: 2em;
    cursor: pointer;
    color: #56050D;
`;

const SearchResultsModal = ({ isOpen, onClose, onClickResult, searchResults }) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalHeaderContainer>
                <ModalHeaderTitleContainer>
                    <h2 style={{ margin: 0 }}>Search Results</h2>
                </ModalHeaderTitleContainer>
                <ModalHeaderCloseButtonContainer>
                    <CloseButton onClick={onClose}>&times;</CloseButton>
                </ModalHeaderCloseButtonContainer>
            </ModalHeaderContainer>
            <hr style={{ margin: '0.5rem 0' }} />
            
            {searchResults && searchResults.length > 0 ? (
                <>
                    <p style={{ marginTop: 8, marginBottom: 16 }}>Click on a result to continue with your invitation.</p>
                    {searchResults.map(result => (
                        <ResultCardContainer key={result.id} onClick={() => onClickResult(result)}>
                            <ResultCardContent>
                                <h3 style={{ marginTop: 4, marginBottom: 4 }}>{result.name}</h3>
                                <h4 style={{ marginTop: 0, marginBottom: 8 }}>{result.email}</h4>
                            </ResultCardContent>
                            <ResultCardArrowContainer>
                                <ResultCardArrow>&rarr;</ResultCardArrow>
                            </ResultCardArrowContainer>
                        </ResultCardContainer>
                    ))}
                </>
                
            ) : (
                <h3>No results found.</h3>
            )}
        </Modal>
    );
};

export default SearchResultsModal;